import { render, staticRenderFns } from "./configs-popup-edit-info.vue?vue&type=template&id=6df634f2&scoped=true"
import script from "./configs-popup-edit-info.vue?vue&type=script&lang=js"
export * from "./configs-popup-edit-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df634f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df634f2')) {
      api.createRecord('6df634f2', component.options)
    } else {
      api.reload('6df634f2', component.options)
    }
    module.hot.accept("./configs-popup-edit-info.vue?vue&type=template&id=6df634f2&scoped=true", function () {
      api.rerender('6df634f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/popups/configs-popup-edit-info.vue"
export default component.exports